import { AdaptivePracticeContext, AppContext } from "../../../context/context";
import { PlayFrame } from "../frame/PlayFrame";
import { ContentFactoryImpl, Content } from '@mathbuddy/adaptive-practice-engine';
import { getTimeSpent, toggleFullSceen } from '../../../utils/utils';
import { Component } from "react";
import { StatusCodes } from "http-status-codes";
import apis from "../../../apis/api";
import { userAction } from "../../../reduxStore";
import { connect } from "react-redux";
import { ls } from "../../../localStorage";
import { AssessmentQuestionStatus } from "../interface/interface";
import { IAdaptiveSessionInfo } from "../../../interface/interface";
import { ReferenceMaterialForAssessment } from "./reference/ReferenceMaterialForAssessment";
import { AssessmentInstructions } from "./instructions/AssessmentInstructions";
import { applyTheme, resolveTheme } from '../theme';


class RiseAssessmentForStudents extends Component<any, any> {
    static contextType = AppContext;
    context!: { windowHeight: string, windowWidth: string, messageForParent: any, navigateTo: any };
    constructor(props: any) {
        super(props)
        this.state = {
            // Optional `theme` prop from the parent; falls back to this screen's own
            // default. Resolved once - the theme cannot change between questions.
            theme: resolveTheme(props.theme),
            currentUser: this.props.currentUser,
            sessionInfo: this.props.sessionInfo,
            skillId: this.props.skillId,
            langObj: { number_lang: '', lang: '' },
            contentFactoryObj: new ContentFactoryImpl(),
            contentObj: new Content(),
            response: { component: [] },
            isNewSession: true,
            isLoader: false,
            currentQuestionPosition: 0,
            startTime: 0,
            questionsList: [] as { id: string, skill_id: string, reviewObj: any, status: AssessmentQuestionStatus }[],
            domSnapShot: {},
            isShowAdaptivePopup: false,
            isShowStartPopup: false,
            isCloseFromClick: false,
            isSafeZone: false,
            coinsEarned: 0,
            isLastQuestion: false,
            initialTime: 3600, // 3600 sec is 1hr.
            isTimeout: false,
            isReview: true,
            isSubmitted: false,
            showReferenceScreen: false,
        }
    }

    componentDidMount = () => {
        // Paint the frame ONCE per screen - 21 custom properties, not a per-question cost.
        applyTheme(this.state.theme);
        this.getLatestStateOnMount();
    }

    calculateInitialTime = (timeSpent: number) => {
        const sessionInfo: IAdaptiveSessionInfo = this.state.sessionInfo;
        const sessionTime = sessionInfo.sessionTime || 3600;
        return sessionTime - timeSpent;
    }

    getLatestStateOnMount = async () => {
        await this.sendLastAttemptedIfAny(); // if window is reloaded and last attempted questions is there send it to DB.
        this.setState({ isLoader: true });

        let sessionStatus = await this.getSessionStatus();
        let currentUser = this.props.currentUser;
        let country_code = currentUser.country_code;

        let langObj = { number_lang: 'en', lang: this.props.lang + '_' + country_code.toLowerCase() };


        const userObj = {
            env: process.env.REACT_APP_ENV, userId: currentUser.id,
            classroomId: currentUser.classroom_id,
            dbToken: currentUser.dbToken, token: ls.getToken()
        };
        const sessionInfo = this.state.sessionInfo;

        const questionsList = sessionStatus.isReview ?
            await this.state.contentObj.getAssessmentQuestionsById(sessionInfo.adaptiveId) :
            await this.state.contentObj.getAssessmentQuestionsByUser(userObj,
                sessionInfo.sessionId, sessionInfo.adaptiveId);

        console.log(questionsList);
        questionsList.forEach((q: any) => {
            if (sessionStatus.isReview) {
                const questionKey = q.id + '_' + q.skill_id;
                q.review = (sessionStatus.reviewQuestionRes[questionKey]) !== undefined ?
                    sessionStatus.reviewQuestionRes[questionKey] :
                    {
                        isAttempted: false, isCorrect: false,
                        userInput: null,
                        correctAnswer: q.reviewObj?.answerObj,
                    }
            }
            else {
                q.review = {}
                q.status = AssessmentQuestionStatus.notVisited;
            }

        });

        console.log(sessionStatus);
        this.setState({
            ...sessionStatus,
            langObj,
            isLoader: false,
            questionsList
        }, () => {
            if (!this.state.isShowStartPopup)
                this.loadSessionContent();
        })
    }

    getSessionStatus = async () => {
        let returnObj = {
            totalAttemptedCount: 0,
            totalCorrectAttemptedQuestion: 0,
            isReview: false,
            reviewQuestionRes: {} as { [key: string]: any },
            isShowStartPopup: false,
            initialTime: 0,
        }

        const user_id = this.state.currentUser.id;
        const session_id = this.state.sessionInfo.sessionId;
        let timeSpent = 0;
        let skillStatusRes = await apis._getAdaptiveSessionStatus(user_id, session_id);

        //console.log(skillStatusRes);
        if (skillStatusRes?.data?.code === StatusCodes.OK) {
            const sessionStatus = skillStatusRes.data.result;
            if (sessionStatus) {
                returnObj.totalAttemptedCount = sessionStatus.total_questions;
                returnObj.totalCorrectAttemptedQuestion = sessionStatus.correct_answers;
                returnObj.isReview = sessionStatus.isCompleted ? true : false;
                returnObj.isShowStartPopup = !returnObj.isReview;
                timeSpent = sessionStatus.time_spent;
            }
        }

        returnObj.initialTime = this.calculateInitialTime(timeSpent);

        if (returnObj.isReview) {
            const questionRes = await apis._getAdaptiveSessionQuestion(user_id, session_id);
            console.log(questionRes);

            if (questionRes.status === StatusCodes.OK && questionRes.data.result.data.length > 0) {
                const Q_RES = questionRes.data.result.data;
                const Q_Review: any = {};

                Q_RES.map((q: any) => {
                    const questionKey = q.question_id + '_' + q.lo_id;
                    Q_Review[questionKey] = {
                        isAttempted: true,
                        isCorrect: q.isCorrect,
                        userInput: q.answers[q.answers.length - 1].answer,
                        correctAnswer: q.review_obj.answerObj,
                    };
                });

                returnObj.reviewQuestionRes = Q_Review;
            }

        }

        return returnObj;
    }

    loadSessionContent = async () => {
        try {
            this.setState({ isLoader: true, response: { component: [] } });

            const currentQuestionPosition = this.state.currentQuestionPosition;
            const langObj = this.state.langObj;

            let currentQuestion: {
                id: string,
                skill_id: string,
                safeZone?: boolean, reviewObj: any
                status: AssessmentQuestionStatus
            } = this.state.questionsList[currentQuestionPosition];


            let isLastQuestion = (currentQuestionPosition === (this.state.questionsList.length - 1));
            await this.state.contentObj.loadSkillBySkillId(currentQuestion.skill_id, this.state.theme, langObj.lang);

            let response = await this.state.contentFactoryObj.displayQuestion(this.state.contentObj,
                this.state.contentObj.createContentTemplateObject(currentQuestion.id, 'REACT_WEB'), langObj, currentQuestion.reviewObj);
            console.log("response_skills", response, this.state.lastResponses);

            this.setState({
                startTime: new Date(),
                response,
                isLastQuestion
            }, () => {
                //console.log(this.state);
                this.setState({ isLoader: false });

                if (currentQuestion.status === AssessmentQuestionStatus.notVisited)
                    this.manageAssessmentQuestions(AssessmentQuestionStatus.unanswered);
            })

        } catch (error) {
            this.setState({ isLoader: false })
        }
    }

    saveSnapShot = (innerHTML: string) => {
        if (innerHTML) {
            let domSnapShot: { [key: number]: string } = this.state.domSnapShot;
            domSnapShot[this.state.currentQuestionPosition] = innerHTML;
            this.setState({ domSnapShot });
        }
    }

    onClearSnapShot = () => {
        this.manageAssessmentQuestions(AssessmentQuestionStatus.unanswered);
        let domSnapShot: { [key: number]: string } = this.state.domSnapShot;
        delete domSnapShot[this.state.currentQuestionPosition];
        this.setState({ domSnapShot });
    }

    manageAssessmentQuestions = (
        status: AssessmentQuestionStatus,
        answerObj: {
            givenAnswer: any,
            actualAnswer: any,
            isCorrectAns: Boolean
        } = { givenAnswer: null, actualAnswer: null, isCorrectAns: false }) => {

        const current = this.state.currentQuestionPosition;
        const questionsList = this.state.questionsList;
        questionsList[current].status = status;
        this.setState({ questionsList });

        const assessmentQuestions = this.props.userReducer.assessmentQuestions;
        const priviouslyAttempted = assessmentQuestions.questions || {};

        const currentQuestion: { id: string, skill_id: string, reviewObj: any } = questionsList[current];
        const questionKey = currentQuestion.id + '_' + currentQuestion.skill_id;
        const reviewObj = this.state.response.reviewObj;
        reviewObj.mappedContent.allVars = undefined;

        const currentQuestionObj = priviouslyAttempted[questionKey] || {
            "isNewSession": this.state.isNewSession,
            "user_id": this.state.currentUser.id,
            "session_id": this.state.sessionInfo.sessionId,
            "lo_id": currentQuestion.skill_id,
            "question_id": currentQuestion.id,
            "review_obj": reviewObj,
            "number_lang": this.state.langObj.number_lang,
            "lang": this.state.langObj.lang,
            "answers": [],
            "isCorrect": false,
            "isStreakFreeze": true,
            "isSafeZone": false,
            "blooms": this.state.response.blooms,
            "time_spent": 0,
        };

        const time_spent = getTimeSpent(this.state.startTime);
        currentQuestionObj.answers = [{ "isCorrect": answerObj.isCorrectAns, "answer": answerObj.givenAnswer }];
        currentQuestionObj.isCorrect = answerObj.isCorrectAns;
        currentQuestionObj.time_spent += time_spent;

        priviouslyAttempted[questionKey] = currentQuestionObj;

        let data = {
            questions: priviouslyAttempted,
            qualifier: "ASSESSMENT",
            sessionNumber: this.state.sessionInfo.sessionNo,
            sessionQuestionIds: this.state.questionsList.map((q: { id: string, skill_id: string }) => `${q.id}_${q.skill_id}`)
        }

        const isLoadNextQuestion = this.state.isLastQuestion ? false : status === AssessmentQuestionStatus.answered;
        const currentQuestionPosition = isLoadNextQuestion ? current + 1 : current;

        let coinsEarned = 0;
        this.props.userReducer.assessmentQuestions.questions &&
            Object.values(this.props.userReducer.assessmentQuestions.questions).forEach((q: any) => {
                coinsEarned += q.answers.filter((a: any) => a.isCorrect).length;
            });

        // if (status === AssessmentQuestionStatus.answered) {
        this.context.messageForParent('setUserScoreToRedisForRZ', {
            questions: Object.values(priviouslyAttempted),
        })
        // }

        this.setState({
            coinsEarned,
            isNewSession: false,
            questionsList,
            currentQuestionPosition
        },
            () => {
                this.props.setAssementQuestions(data); // set assessment questions in redux store.
                if (isLoadNextQuestion)
                    this.loadSessionContent();
            });
    }

    onAnswer = async (answerObj: { givenAnswer: any, actualAnswer: any, isCorrectAns: Boolean }, clickCount: number) => {
        this.manageAssessmentQuestions(AssessmentQuestionStatus.answered, answerObj);
    }

    onClickSubmit = () => { this.setShowAdaptivePopup(true); }

    onSubmit = async (isTimeout: boolean = false) => {
        this.setState({
            isSubmitted: true,
            initialTime: 0,
            isShowAdaptivePopup: false
        }, async () => {
            await this.sendLastAttemptedIfAny(isTimeout);
            this.setShowAdaptivePopup(false);
        });
    }

    saveQuestionResponseToDB = async (data: any) => {
        let response = await apis._saveQuestionResponseForAdaptiveSession(data);
        // if (response?.status === StatusCodes.OK) {
        this.props.setAssementQuestions({ questions: {}, sessionNumber: 0, sessionQuestionIds: [] }); // clear assessment questions in redux store.
        this.context.messageForParent('updateUserReducerForAdaptiveSession', {
            questions: data.questions,
            isSubmited: this.state.isSubmitted
        })
        // }
        return response;
    }

    getPopUpInfo = () => {
        let showAnimation = this.state.isSubmitted && this.state.coinsEarned > 0 ? true : false;

        let heading = this.state.isShowStartPopup ?
            "You are about to begin an assessment. You will be given a set of questions to answer." :
            !this.state.isReview && !this.state.isSubmitted ?
                "Are you sure you want to submit your assessment? You won't be able to change your answers once submitted." :
                "Your assessment is submitted successfully!";

        return {
            streaks: this.state.streaks,
            isShowStartPopup: this.state.isShowStartPopup,
            isAssessment: true,
            assessment: {
                answered: this.state.questionsList.filter((q: any) => q.status === AssessmentQuestionStatus.answered).length,
                // Everything that is not answered, whether it was opened and left or never reached.
                unanswered: this.state.questionsList.filter((q: any) => q.status !== AssessmentQuestionStatus.answered).length,
                coinsEarned: this.state.isSubmitted ? this.state.coinsEarned : 0,
                total: this.state.questionsList.length
            },
            stopBtnText: this.state.isSubmitted ? "Okay" : "Submit",
            isCloseFromClick: this.state.isCloseFromClick,
            heading, showAnimation
        }
    }

    setShowAdaptivePopup = (isCloseFromClick: Boolean = false) => {
        let isShowAdaptivePopup = !this.state.isShowAdaptivePopup
        if (isCloseFromClick && this.state.isReview)
            this.onClose();
        else
            this.setState({ isCloseFromClick, isShowAdaptivePopup });
    }

    setShowStartPopup = (status: boolean) => {
        this.setState({ isShowStartPopup: status })
        if (!status) {
            toggleFullSceen('fullScreen');
            this.loadSessionContent();
        }
    }

    sendLastAttemptedIfAny = async (isTimeout: boolean = false) => {
        let assessmentQuestions = this.props.userReducer.assessmentQuestions;
        const priviouslyAttempted = assessmentQuestions.questions || {};
        if (Object.keys(priviouslyAttempted).length === 0)
            return;

        assessmentQuestions.questions = Object.values(priviouslyAttempted);
        if (isTimeout) {
            assessmentQuestions.isAssessmentTimeout = true;
            assessmentQuestions.assessmentTime = 3600;
        }
        if (assessmentQuestions.questions.length) {
            this.setState({ isLoader: true });
            await this.saveQuestionResponseToDB(assessmentQuestions);
            this.setState({ isLoader: false });
        }
        console.log(assessmentQuestions);
    }

    onClose = async () => {
        await this.sendLastAttemptedIfAny();
        this.context.messageForParent('close');
    }

    showReferenceScreen = (value: boolean) => {
        this.setState(
            { isShowReferenceScreen: value }
        );
    };
    

    render() {
        return (
            <AdaptivePracticeContext.Provider value={{
                notificationMessage: this.state.notificationMessage,
                isSafeZone: this.state.isSafeZone,
                isLastQuestion: this.state.isLastQuestion,
                meter: { percentage: 0, level: '' },
                isLoader: this.state.isLoader,
                isCoinAnimation: this.state.isCoinAnimation,
                isShowStartPopup: this.state.isShowStartPopup,
                isShowAdaptivePopup: this.state.isShowAdaptivePopup,
                isCloseFromClick: this.state.isCloseFromClick,
                engineObj: this.state.response,
                ...(this.state.questionsList.length === 0 ? {} : this.state.isReview ? { reviewMode: this.state.questionsList[this.state.currentQuestionPosition].review } : {}),
                options: {
                    isShowClose: this.state.isReview,
                    isToggleFullSceren: this.state.isReview,
                    isShowReference: !this.state.isReview,
                    showReferenceScreen: this.showReferenceScreen,
                    isShowExpNext: false,
                    isMusicAllowed: false,
                    ...(this.state.questionsList.length === 0 ? {} : this.state.isReview ? {
                        questionSummaryHeader: {
                            current: this.state.currentQuestionPosition,
                            total: this.state.questionsList.length,
                            setCurrentPos: (pos: number) => {
                                this.setState({ currentQuestionPosition: pos }, () => {
                                    this.loadSessionContent();
                                })
                            }
                        }
                    } : {
                        questionSummaryHeader: {
                            timer: {
                                initialTime: this.state.initialTime,
                                isStarted: !this.state.isShowStartPopup,
                                onTimerEnd: async () => {
                                    console.log("Timer ended");
                                    this.setState({ isTimeout: true });
                                    this.onSubmit(true);
                                }
                            },
                            questionsStatus: this.state.questionsList.map((q: any) => q.status),
                            current: this.state.currentQuestionPosition,
                            total: this.state.questionsList.length,
                            setCurrentPos: (Pos: number) => {
                                this.setState({ currentQuestionPosition: Pos }, () => {
                                    this.loadSessionContent();
                                })
                            }
                        },
                        snapShot: {
                            innerHTML: this.state.domSnapShot[this.state.currentQuestionPosition],
                            saveSnapShot: this.saveSnapShot,
                            // Unchanged behaviour, said explicitly now: Rise offers Clear for a
                            // question it is showing from a snapshot.
                            clearSnapShot: this.state.domSnapShot[this.state.currentQuestionPosition]
                                ? this.onClearSnapShot
                                : undefined
                        },
                        onSubmit: this.onClickSubmit,
                    }),
                },
                loadContent: this.loadSessionContent,
                saveQuestionResponse: this.onAnswer,
                getPopUpInfo: this.getPopUpInfo,
                setShowAdaptivePopup: this.setShowAdaptivePopup,
                setShowStartPopup: this.setShowStartPopup,
                onclose: !this.state.isReview && !this.state.isSubmitted ? this.onSubmit : this.onClose
            }}>
                {/* this.props.currentUser.grade */}
                <PlayFrame></PlayFrame>
                {(this.state.isShowReferenceScreen) && (
                    <ReferenceMaterialForAssessment />
                )}
                {(!this.state.isLoader && (this.state.isShowStartPopup)) && (
                    <AssessmentInstructions />
                )}
            </AdaptivePracticeContext.Provider>
        )
    }
}

function mapStateToProps(state: any) {
    return state;
}

let setAssementQuestions = userAction.setAssessmentQuestions;
const mapDispatchToProps = { setAssementQuestions };

export default connect(mapStateToProps, mapDispatchToProps)(RiseAssessmentForStudents);